(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eb-product-gallery-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eb-product-gallery-viewer')) {
    class EbProductGalleryViewer extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('.ebpg-stage');
        this.canvas = this.querySelector('.ebpg-canvas');
        this.image = this.querySelector('.ebpg-image');
        this.images = JSON.parse(this.querySelector('[data-ebpg-images]').textContent);
        this.bound = new WeakSet();
        this.pointers = new Map();
        this.scale = 1;
        const options = { signal: this.abort.signal };
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-ebpg-close]')) this.dialog.close();
          if (event.target.closest('[data-ebpg-prev]')) this.step(-1);
          if (event.target.closest('[data-ebpg-next]')) this.step(1);
          if (event.target.closest('[data-ebpg-in]')) this.zoom(this.scale + .5);
          if (event.target.closest('[data-ebpg-out]')) this.zoom(this.scale - .5);
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === '+' || event.key === '=') { event.preventDefault(); this.zoom(this.scale + .5); }
          if (event.key === '-') { event.preventDefault(); this.zoom(this.scale - .5); }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('ebpg-locked');
          this.pointers.clear();
          this.opener?.focus({ preventScroll: true });
        }, options);
        this.image.addEventListener('load', () => this.fit(), options);
        this.stage.addEventListener('pointerdown', (event) => this.startPointer(event), options);
        this.stage.addEventListener('pointermove', (event) => this.movePointer(event), options);
        this.stage.addEventListener('pointerup', (event) => this.endPointer(event), options);
        this.stage.addEventListener('pointercancel', () => { this.pointers.clear(); this.pinch = null; this.dragged = true; this.dialog.dataset.dragging = 'false'; }, options);
        window.addEventListener('resize', () => { if (this.dialog.open) this.fit(); }, options);
        document.addEventListener('shopify:section:load', () => this.init(), options);
        this.init();
        const main = document.getElementById('MainContent');
        if (main) {
          this.observer = new MutationObserver((records) => {
            if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.(this.gallerySelector) || node.querySelector?.(this.gallerySelector))))) this.init();
          });
          this.observer.observe(main, { childList: true, subtree: true });
        }
      }
      get gallerySelector() { return '.ebpdp-gallery, .ebtal__gallery, .eb-fleece-gallery, .eb-sport-gallery'; }
      get thumbSelector() { return '[data-ebpdp-image], [data-ebtal-image], [data-fleece-thumb], [data-sport-thumb]'; }
      key(src) { try { return new URL(src, location.href).pathname; } catch { return src; } }
      init() {
        document.querySelectorAll(this.gallerySelector).forEach((gallery) => {
          if (this.bound.has(gallery)) return;
          const image = gallery.querySelector('.ebpdp-main-img, .ebtal__main-image, .eb-fleece-main-image, .eb-sport-main-image');
          if (!image) return;
          this.bound.add(gallery);
          const thumbs = gallery.querySelector('.ebpdp-thumbs, .ebtal__thumbs, .eb-fleece-thumbs, .eb-sport-thumbnails');
          const main = gallery.querySelector('.ebpdp-media, .ebtal__media, .eb-fleece-hero, .eb-sport-stage');
          if (!main) return;
          gallery.classList.add('ebpg-gallery');
          main.classList.add('ebpg-main');
          thumbs?.classList.add('ebpg-thumbs');
          if (thumbs && thumbs.parentElement === gallery && main.parentElement === gallery) gallery.insertBefore(thumbs, main);
          gallery.classList.toggle('ebpg-single', !thumbs);
          let trigger = image.closest('button');
          if (!trigger) {
            trigger = this.querySelector('[data-ebpg-trigger]').content.firstElementChild.cloneNode(true);
            image.before(trigger);
            trigger.prepend(image);
          }
          trigger.setAttribute('aria-haspopup', 'dialog');
          const options = { signal: this.abort.signal, capture: true };
          let pointerStart;
          let moved = false;
          gallery.addEventListener('pointerdown', (event) => { pointerStart = [event.clientX, event.clientY]; moved = false; }, options);
          gallery.addEventListener('pointermove', (event) => {
            if (pointerStart && event.buttons) moved = Math.hypot(event.clientX - pointerStart[0], event.clientY - pointerStart[1]) > 10;
          }, options);
          gallery.addEventListener('click', (event) => {
            const thumb = event.target.closest(this.thumbSelector);
            if (thumb) {
              if (thumb.hasAttribute('data-ebpdp-image') || thumb.hasAttribute('data-ebtal-image')) {
                image.removeAttribute('srcset');
                image.removeAttribute('sizes');
                image.alt = thumb.querySelector('img')?.alt || image.alt;
              }
              queueMicrotask(() => this.sync(gallery));
              return;
            }
            if (event.target.closest('button') !== trigger) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!moved) this.open(gallery, image, trigger);
            moved = false;
          }, options);
          gallery.addEventListener('keydown', (event) => {
            const thumb = event.target.closest(this.thumbSelector);
            if (!thumb || !['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const list = [...gallery.querySelectorAll(this.thumbSelector)];
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? list.length - 1 : (list.indexOf(thumb) + (event.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
            list[index].focus();
            list[index].click();
          }, options);
          this.sync(gallery);
        });
      }
      sync(gallery) {
        gallery.querySelectorAll('[data-ebpdp-image], [data-ebtal-image]').forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.classList.contains('is-active'))));
      }
      source(thumb) {
        const img = thumb.querySelector('img');
        const src = thumb.dataset.ebpdpImage || thumb.dataset.ebtalImage || thumb.dataset.src || img?.src;
        const mapped = this.images.find((item) => this.key(item.src) === this.key(src));
        return { src: thumb.dataset.zoomSrc || mapped?.zoom || src, alt: img?.alt || '' };
      }
      open(gallery, image, opener) {
        this.opener = opener;
        this.items = [...gallery.querySelectorAll(this.thumbSelector)].map((thumb) => this.source(thumb));
        const mapped = this.images.find((item) => this.key(item.src) === this.key(image.src));
        const current = { src: opener.dataset.zoomSrc || mapped?.zoom || image.src, alt: image.alt };
        this.index = this.items.findIndex((item) => this.key(item.src) === this.key(current.src));
        if (this.index < 0) { this.items.unshift(current); this.index = 0; }
        this.items[this.index] = current;
        this.dialog.showModal();
        document.documentElement.classList.add('ebpg-locked');
        this.show();
      }
      show() {
        this.scale = 1;
        this.pointers.clear();
        this.dragged = false;
        this.image.src = this.items[this.index].src;
        this.image.alt = this.items[this.index].alt;
        this.querySelector('.ebpg-count').textContent = `${this.index + 1} / ${this.items.length}`;
        this.querySelectorAll('[data-ebpg-prev], [data-ebpg-next]').forEach((button) => { button.hidden = this.items.length < 2; });
        if (this.image.complete && this.image.naturalWidth) this.fit();
      }
      step(direction) {
        this.index = (this.index + direction + this.items.length) % this.items.length;
        this.show();
      }
      fit() {
        if (!this.dialog.open || !this.image.naturalWidth) return;
        const ratio = Math.min((this.stage.clientWidth - 24) / this.image.naturalWidth, (this.stage.clientHeight - 24) / this.image.naturalHeight, 1);
        this.base = [this.image.naturalWidth * ratio, this.image.naturalHeight * ratio];
        this.zoom(this.scale);
      }
      zoom(scale) {
        if (!this.base) return;
        const previous = this.scale;
        const x = (this.stage.scrollLeft + this.stage.clientWidth / 2) / Math.max(1, this.canvas.offsetWidth);
        const y = (this.stage.scrollTop + this.stage.clientHeight / 2) / Math.max(1, this.canvas.offsetHeight);
        this.scale = Math.min(3, Math.max(1, scale));
        const width = this.base[0] * this.scale;
        const height = this.base[1] * this.scale;
        this.image.style.width = `${width}px`;
        this.image.style.height = `${height}px`;
        this.canvas.style.width = `${Math.max(this.stage.clientWidth, width + 24)}px`;
        this.canvas.style.height = `${Math.max(this.stage.clientHeight, height + 24)}px`;
        this.dialog.dataset.zoomed = String(this.scale > 1);
        this.querySelector('.ebpg-scale').textContent = `${Math.round(this.scale * 100)}%`;
        this.querySelector('[data-ebpg-out]').disabled = this.scale <= 1;
        this.querySelector('[data-ebpg-in]').disabled = this.scale >= 3;
        if (this.scale === 1) { this.stage.scrollLeft = 0; this.stage.scrollTop = 0; }
        else if (previous !== this.scale) {
          this.stage.scrollLeft = x * this.canvas.offsetWidth - this.stage.clientWidth / 2;
          this.stage.scrollTop = y * this.canvas.offsetHeight - this.stage.clientHeight / 2;
        }
      }
      startPointer(event) {
        if (event.button !== 0) return;
        if (!this.pointers.size) {
          this.dragged = false;
          this.tapImage = event.target === this.image;
        }
        this.pointers.set(event.pointerId, [event.clientX, event.clientY]);
        this.stage.setPointerCapture(event.pointerId);
        this.start = [event.clientX, event.clientY];
        if (this.pointers.size === 2) {
          this.dragged = true;
          const [a, b] = [...this.pointers.values()];
          this.pinch = { distance: Math.hypot(a[0] - b[0], a[1] - b[1]), scale: this.scale };
        }
      }
      movePointer(event) {
        const previous = this.pointers.get(event.pointerId);
        if (!previous) return;
        this.pointers.set(event.pointerId, [event.clientX, event.clientY]);
        if (this.pointers.size === 2 && this.pinch) {
          const [a, b] = [...this.pointers.values()];
          this.zoom(this.pinch.scale * Math.hypot(a[0] - b[0], a[1] - b[1]) / Math.max(1, this.pinch.distance));
          this.dragged = true;
        } else if (this.scale > 1) {
          this.stage.scrollLeft -= event.clientX - previous[0];
          this.stage.scrollTop -= event.clientY - previous[1];
          if (Math.hypot(event.clientX - this.start[0], event.clientY - this.start[1]) > 5) this.dragged = true;
        }
        this.dialog.dataset.dragging = String(this.dragged);
      }
      endPointer(event) {
        if (!this.pointers.has(event.pointerId)) return;
        const wasPinching = Boolean(this.pinch);
        const distance = Math.hypot(event.clientX - this.start[0], event.clientY - this.start[1]);
        if (this.scale === 1 && this.pointers.size === 1 && this.start && !this.pinch) {
          const dx = event.clientX - this.start[0];
          const dy = event.clientY - this.start[1];
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { this.step(dx < 0 ? 1 : -1); this.dragged = true; }
        }
        this.pointers.delete(event.pointerId);
        if (!this.pointers.size && !wasPinching && !this.dragged && distance < 6 && this.tapImage) this.zoom(this.scale > 1 ? 1 : 2);
        if (!this.pointers.size) this.pinch = null;
        this.dialog.dataset.dragging = 'false';
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('ebpg-locked');
        this.abort = null;
      }
    }
    customElements.define('eb-product-gallery-viewer', EbProductGalleryViewer);
  }
  } catch(e) { console.error(e); }
})();

})();
